import { render } from "./CmsTabComponent.vue?vue&type=template&id=c7769792"
import script from "./CmsTabComponent.vue?vue&type=script&lang=js"
export * from "./CmsTabComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__